// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f6e61fc","239":"fc8539b6","455":"da05d659"}[chunkId] + ".chunk.js";
};